import { apiClient } from "../lib/api";

export const article36Api = {
  dashboard: () => apiClient.get("/article36/dashboard"),
  overtimeGate: () => apiClient.get("/article36/overtime-gate"),
  list: () => apiClient.get("/article36/agreements"),
  get: (id) => apiClient.get(`/article36/agreements/${id}`),
  create: (payload) => apiClient.post("/article36/agreements", payload),
  update: (id, payload) => apiClient.patch(`/article36/agreements/${id}`, payload),
  renew: (id) => apiClient.post(`/article36/agreements/${id}/renew`),
  openElection: (id, payload) => apiClient.post(`/article36/agreements/${id}/election`, payload),
  getElection: (electionId) => apiClient.get(`/article36/elections/${electionId}`),
  castVote: (electionId, choice) => apiClient.post(`/article36/elections/${electionId}/vote`, { choice }),
  closeElection: (electionId) => apiClient.post(`/article36/elections/${electionId}/close`),
  certifyElection: (electionId, evidence_note) => apiClient.post(`/article36/elections/${electionId}/certify`, { evidence_note }),
  approve: (id, employer_representative_name) => apiClient.post(`/article36/agreements/${id}/approve`, { employer_representative_name }),
  recordFiling: (id, payload) => apiClient.post(`/article36/agreements/${id}/filing`, payload),
  activate: (id) => apiClient.post(`/article36/agreements/${id}/activate`),
  myElections: () => apiClient.get("/article36/my-elections"),
};
